import React, { useRef, useState, useEffect } from "react";
import TitleSection from "../../components/pageComponents/titleSection/TitleSection";
import HeroSlider from "../../components/pageComponents/heroSlider/HeroSlider";
import NotificationBoard from "../../components/pageComponents/notificationBoard/NotificationBoard";
import PrincipalMessage from "../../components/pageComponents/principalMessage/PrincipalMessage";
import RecentActivityHighlights from "../../components/pageComponents/recentActivityHighlights/RecentActivityHighlights";
import ParentingCorner from "../../components/pageComponents/parentingCorner/ParentingCorner";
import EducationalSources from "../../components/pageComponents/educationalSources/EducationalSources";
import QuickLinks from "../../components/pageComponents/quickLinks/QuickLinks";
import Memories from "../../components/pageComponents/memories/Memories";
import Footer from "../../components/pageComponents/footer/Footer";
import GlobalDialog from "../../components/pageComponents/globalDialog/GlobalDialog";
import WaitForAllImagesToLoad from "../../utils/waitForImagesLoad/WaitForImagesLoad";
import WaitForApiLoad from "../../utils/waitForApiLoad/WaitForApiLoad";
import PagePreloader from "../../theme/pagePreloader/PagePreloader";
import InfiniteMarquee from "../../components/pageComponents/infiniteMarquee/InfiniteMarquee";

const HomeLayout = () => {
  const contactUsRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showPreloader, setShowPreloader] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let timeoutId;

    const loadEverything = async () => {
      // Start a 250ms delay timer
      timeoutId = setTimeout(() => {
        setShowPreloader(true);
      }, 250);

      await Promise.all([
        WaitForAllImagesToLoad(setProgress),
        WaitForApiLoad(),
      ]);

      // Once everything is loaded:
      clearTimeout(timeoutId);
      setIsLoading(false);
      setShowPreloader(false); // just in case 250ms didn't pass
    };

    loadEverything();

    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <div className="home-page">
      {showPreloader && isLoading && <PagePreloader progress={progress} />}

      <div className="marquee-wrapper-homelayout">
        <InfiniteMarquee />
      </div>

      <div className="first-wrapper-homelayout">
        <div className="hero-section-homelayout">
          <div id="schooltitle" className="title-section">
            <TitleSection />
          </div>
          <HeroSlider />
        </div>
        <div className="notification-board-homelayout">
          <NotificationBoard />
        </div>
        <div className="principal-message-homelayout">
          <PrincipalMessage />
        </div>
      </div>

      <div className="wrapper-homelayout second-wrapper-homelayout">
        <div className="quicklinks-homelayout">
          <QuickLinks contactUsRef={contactUsRef} />
        </div>
        <div className="recent-activities-homelayout">
          <RecentActivityHighlights />
        </div>
      </div>

      <div className="second-flex">
        <div className="colored-section third-wrapper-homelayout">
          <div className="educational-sources-homelayout">
            <EducationalSources />
          </div>
        </div>
        <div className="wrapper-homelayout colored-section fourth-wrapper-homelayout">
          <div className="memories-homelayout">
            <Memories />
          </div>
          <div className="parents-corner-homelayout">
            <ParentingCorner />
          </div>
        </div>
        <div
          ref={contactUsRef}
          className="wrapper-homelayout colored-section fifth-wrapper-homelayout"
        >
          <div className="footer-homelayout">
            <Footer />
          </div>
        </div>
      </div>
      <GlobalDialog />
    </div>
  );
};

export default HomeLayout;
